import {useCallback, useState} from 'react'
import {type PortalModulePrefs, isModuleNewPortalEnabled} from 'src/lib/portal-migration/portal-module-prefs'
import {readPortalModulePrefsFromClientCookie, writePortalModulePrefsToClientCookie} from 'src/lib/portal-migration/portal-module-prefs.client'

export function usePortalModulePrefs() {
  const [prefs, setPrefs] = useState<PortalModulePrefs>(() => readPortalModulePrefsFromClientCookie())

  const refreshPrefs = useCallback(() => {
    setPrefs(readPortalModulePrefsFromClientCookie())
  }, [])

  const setModuleEnabled = useCallback((moduleId: string, enabled: boolean) => {
    setPrefs((current) => {
      const next = {...current, [moduleId]: enabled}
      writePortalModulePrefsToClientCookie(next)
      return next
    })
  }, [])

  const isModuleEnabled = useCallback((moduleId: string) => isModuleNewPortalEnabled(moduleId, prefs), [prefs])

  return {prefs, setModuleEnabled, isModuleEnabled, refreshPrefs}
}
